var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    fill: "#0F5EFF",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18626_21379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.723 36.0215H37.16C43.6308 36.0215 48.8829 40.8154 48.8829 46.7217C48.8829 47.9142 47.822 48.8825 46.5155 48.8825H17.3674C16.0609 48.8799 15 47.9142 15 46.7217C15 40.8154 20.2521 36.0215 26.723 36.0215Z",
    fill: "#0F5EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9393 34.485C37.8343 34.485 42.6131 30.1231 42.6131 24.7425C42.6131 19.3619 37.8343 15 31.9393 15C26.0444 15 21.2656 19.3619 21.2656 24.7425C21.2656 30.1231 26.0444 34.485 31.9393 34.485Z",
    fill: "#0F5EFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18626_21379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.88,
    height: 33.88,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerCardIcon);
export default __webpack_public_path__ + "static/media/customerCardIcon.6f70d66c01dbd5ad68fc6b6b19c4a18f.svg";
export { ForwardRef as ReactComponent };